module.exports = function anonymous(it
) {
var out='<li class="alert ';if(it.result === "DISCARDED"){out+='alert-warning';}else{out+='alert-error';}out+='" style="list-style:none; margin-bottom:5px;"> '+(it.errorDesc)+'</li>';return out;
}